import { defineStore, acceptHMRUpdate } from 'pinia'
import { STORAGE_KEYS, useCache } from '@/libs/utils/constants.ts'
import store from '../index'
import { logout, getPermissionInfo, getConsultant } from '@/api/login'
import { usePermissionStore } from '@/store/modules/permission'
import { useWebSocketStore } from '@/store/modules/websocket'
import { userBindDetail } from '@/api/manage/clinicSetting'
import { getCurrentChainContext } from '@/api/manage/chainSetting'
export const useUserStore = defineStore({
  id: STORAGE_KEYS.USER_INFO,
  state: () => ({
    tenantId: null,
    deptId: null,
    accessToken: null,
    refreshToken: null,
    userInfo: null,
    bindYishitongInfo: null,
    consultantInfo: null,
  }),
  getters: {
    getToken: (state): string => {
      return state.accessToken
    },
    getRefreshToken: (state): string => {
      return state.refreshToken
    },
    getTenant: state => {
      return state.tenantId
    },
    getDept: state => {
      return state.deptId
    },
    hasLogged: (state): boolean => !!state.accessToken,
    //TODO:需要获取用户信息后使用此逻辑 !!state.token && !!state.userInfo?.userId,
    getUserInfo: state => {
      return state.userInfo
    },
    getBindYishitongInfo: state => {
      return state.bindYishitongInfo
    },
    // 一级门店
    getIsMaster: state => {
      // headquartersFlag 为 true 时，为总部
      // mechanismStatus 为 true 时，门店是否连锁
      if (
        !state.userInfo?.mechanismStatus ||
        state.userInfo?.headquartersFlag
      ) {
        return true
      }
      return false
    },
  },
  actions: {
    async logout() {
      try {
        await logout()
      } catch (error) {}
      this.removeToken()
      this.setUserInfo()
      window.location.reload()
    },
    setToken(data: string) {
      this.accessToken = data
      // 登录成功后启动 WebSocket 连接
    },
    setTokens(accessToken: string, refreshToken: string) {
      this.accessToken = accessToken
      this.refreshToken = refreshToken
    },
    setOpenId(data) {
      this.userInfo.openId = data
      // 微信绑定状态
    },
    setTenant(data) {
      this.tenantId = data
    },
    setDept(data) {
      this.deptId = data
    },
    removeToken() {
      const { wsCache } = useCache()
      // 401 时断开 WebSocket 连接
      const wsStore = useWebSocketStore()
      wsStore.disconnect()
      this.accessToken = null
      this.refreshToken = null
      this.tenantId = null
      this.deptId = null
      wsCache.delete(STORAGE_KEYS.USER_INFO)
      wsCache.delete('packageDialogClosedDate')
      wsCache.delete('drugDialogClosedDate')
    },
    setUserInfo(data?: object) {
      if (!data) {
        this.userInfo = null
        return
      }
      if (!this.userInfo) {
        this.userInfo = {}
      }
      Object.assign(this.userInfo, data || {})
    },
    async getGuwenInfo() {
      if (this.userInfo?.consultantId) {
        if (this.consultantInfo) {
          return this.consultantInfo ?? {}
        } else {
          const res = await getConsultant({
            id: this.userInfo?.consultantId,
          })
          if (res.code == 0) {
            this.consultantInfo = res.data ?? {}
            return res.data ?? {}
          }
        }
      }
    },
    async initUserInfo() {
      const permissionStore = usePermissionStore()
      const res = await getPermissionInfo()
      if (res.code == 0) {
        this.setUserInfo(res.data)
        // 工作台权限
        let obj = [
          {
            'id': 10,
            'parentId': 0,
            'name': '工作台',
            'sort': 1,
            'path': '/dashboard',
            'icon': 'icon-gongzuotai',
            'component': '/dashboard',
            'componentName': '/dashboard',
            'status': true,
            'type': 1,
            'createTime': null,
            'children': null,
          },
        ]
        if (res.data.headquartersFlag) {
          obj = []
        }
        permissionStore.initRoutesAsync(
          [...obj, ...(res.data?.menuTree ?? [])] ?? []
        )
        this.getGuwenInfo()
      }
    },
    removeUserInfo() {
      this.userInfo = null
    },
    // 是否管理员或超级管理员
    isAdmin() {
      if (
        (this.userInfo?.roleIds ?? []).some(e => e == 6) ||
        (this.userInfo?.roleCodes ?? []).some(e => e == 'tenant_admin')
      ) {
        return true
      } else {
        return false
      }
    },
    // 检查是否有某个菜单权限
    checkMeunId(componentName) {
      const permissionStore = usePermissionStore()
      // 管理员
      if (this.isAdmin()) return true
      // 普通成员
      if (
        permissionStore.getRoutes.some(e => e.componentName == componentName)
      ) {
        return true
      } else {
        return false
      }
    },
    async setBinYishitongInfo() {
      const res = await userBindDetail()
      if (res.code == 0) {
        this.bindYishitongInfo = res.data
      }
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: localStorage, // $localStorage,
        paths: [
          'accessToken',
          'refreshToken',
          'tenantId',
          'deptId',
          'userInfo',
        ], //可以选择保存的字段  其余的不保存
      },
    ],
  },
})
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUserStore, import.meta.hot))
}
export const useUserStoreWithout = () => {
  return useUserStore(store)
}
